export default __webpack_public_path__ + "static/media/scalar.f40c9691.svg";